<template>
    <DxToolbar style="height: 56px" class="toolbar">
        <DxItem location="before" locate-in-menu="never">
            <template #default>
                <routerVue :breadcrumbsItems="breadcrumbsItems" />
            </template>
        </DxItem>
        <DxItem location="after" locate-in-menu="never">
            <div class="row">
                <DxButton
                    text="Hủy"
                    type="danger"
                    styling-mode="text"
                    class="mr-4"
                    @click="$router.go(-1)"
                />
                <DxButton
                    text="Khai báo vé"
                    type="default"
                    styling-mode="contained"
                    @click="KhaiBaoVe"
                />
            </div>
        </DxItem>
    </DxToolbar>

    <ThongTinKhaiBaoVeVue ref="ThongTinKhaiBaoVeVue" />

    <DxPopup
        v-if="ifPopupXacNhanKhaiBaoVe"
        v-model:visible="PopupXacNhanKhaiBaoVe"
        :drag-enabled="false"
        :close-on-outside-click="false"
        :show-title="false"
        :width="424"
        height="auto"
        @hidden="onHidden('PopupXacNhanKhaiBaoVe')"
    >
        <DxScrollView ref="DxScrollViewThongBao" width="100%" height="100%">
            <PopupXacNhanVue
                :Params="ParamsXacNhanKhaiBaoVe"
                @click="XacNhanKhaiBaoVe"
            />
        </DxScrollView>
    </DxPopup>
</template>
<script>
import { DxButton, DxScrollView, DxPopup } from "devextreme-vue";
import { DxToolbar, DxItem } from "devextreme-vue/toolbar";
import routerVue from "@sonphat/common-v1/components/router.vue";
import ThongTinKhaiBaoVeVue from "./components/ThongTinKhaiBaoVe.vue";
import PopupXacNhanVue from "@sonphat/common-v1/components/PopupXacNhan";

export default {
    components: {
        routerVue,
        DxToolbar,
        DxItem,
        ThongTinKhaiBaoVeVue,
        DxButton,
        DxScrollView,
        DxPopup,
        PopupXacNhanVue,
    },
    props: {},
    data() {
        return {
            breadcrumbsItems: [
                {
                    id: "breadcrums_DieuDo",
                    text: "Khai báo vé",
                    disabled: true,
                    to: "",
                },
            ],
            ifPopupXacNhanKhaiBaoVe: false,
            PopupXacNhanKhaiBaoVe: false,
            ParamsXacNhanKhaiBaoVe: {
                WidthTitle: "95%",
                Title: "Bạn chắc chắn thông tin khai báo vé đã chính xác?",
                btnLeft: "HỦY",
                btnRight: "XÁC NHẬN",
            },
        };
    },
    computed: {
        ThongTinKhaiBaoVe: {
            get() {
                return this.$store.state.KhaiBaoVe.ThongTinKhaiBaoVe;
            },
            set(data) {
                this.$store.commit("KhaiBaoVe/Set", {
                    key: "ThongTinKhaiBaoVe",
                    data,
                });
            },
        },
    },
    methods: {
        onHidden(name) {
            this["if" + name] = false;
        },
        showPopup(name) {
            this["if" + name] = true;
            this[name] = true;
        },
        hiddenPopup(name) {
            this[name] = false;
        },
        KhaiBaoVe() {
            let validate =
                this.$refs.ThongTinKhaiBaoVeVue.$refs.formValidation.instance.validate();
            if (!validate.isValid) {
                return this.$Helper.Common.autoFocusError(validate);
            }
            this.showPopup("PopupXacNhanKhaiBaoVe");
        },
        XacNhanKhaiBaoVe(bool) {
            if (bool == false) {
                this.hiddenPopup("PopupXacNhanKhaiBaoVe");
            } else if (bool == true) {
                this.hiddenPopup("PopupXacNhanKhaiBaoVe");
                this.ThucHienKhaiBaoVe();
            }
        },
        async ThucHienKhaiBaoVe() {
            try {
                this.$startLoading;
                let rs = await this.$store.dispatch(
                    "KhaiBaoVe/ThucHienKhaiBaoVe"
                );
                if (rs.status) {
                    this.$Helper.ThongBaoToast(
                        "success",
                        "Khai báo vé thành công!"
                    );
                    if (this.ThongTinKhaiBaoVe.InVe) {
                        return await this.$Events.Print(
                            SP[`Base_Url`],
                            this.$t("urlKhaiBaoVe.LayPhieuInVe"),
                            {
                                DanhSachVe: (rs.data || []).map(
                                    (e) => e.IdVeTiepNhan
                                ),
                            }
                        );
                    }
                } else {
                    this.$Helper.ThongBaoPopup({
                        message_title: "Khai báo vé thất bại!",
                        message: rs.message,
                    });
                }
            } catch (error) {
                console.log("🚀 ~ error:", error);
                this.$Helper.ThongBaoPopup({
                    message_title: "Khai báo vé thất bại!",
                    message: "Lỗi hệ thống client.",
                });
            } finally {
                this.$stopLoading;
            }
        },
    },
    created() {},
    mounted() {},
    beforeUnmount() {
        this.$store.commit("KhaiBaoVe/Reset_ThongTinKhaiBaoVe");
    },
};
</script>
<style scoped></style>
